import './status.scss';

function initStatus(element, options = {}) {
	const settings = {
		color: '#009961',
		backgroundColor: '#b00020',
		...options
	};
	const percentageElement = element.querySelector('[data-status-percentage]');

	if (percentageElement) {
		const percentage = percentageElement.dataset.statusPercentage
			? parseInt(percentageElement.dataset.statusPercentage, 10)
			: 0;

		if (0 < percentage && percentage < 100) {
			let leftPart = 90;
			let leftColor = settings.backgroundColor;
			let rightPart = 270;

			if (percentage < 50) {
				rightPart -= ((50 - percentage) / 50) * 180;
			} else {
				leftPart += ((100 - percentage) / 50) * 180;
				leftColor = settings.color;
			}

			const gradient = `
linear-gradient(${leftPart}deg,  ${leftColor} 50%, transparent 50%,        transparent),
linear-gradient(${rightPart}deg, ${settings.color} 50%,     ${settings.backgroundColor} 50%, ${settings.backgroundColor})
`;

			percentageElement.style.backgroundImage = gradient;

			element.classList.add('ln-status--percentage');
		}
	}
}

const elements = document.querySelectorAll('[data-init="status"]');

elements.forEach(element => {
	initStatus(element);
});

export { initStatus };
